// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"298":"35944994","850":"446f7852"}[chunkId] + ".js";
};